import { SwalMessage, ToastMessage } from '../Tools'


var Support = function () {

    var form;


    var handle = function () {

        // talep gönder
        $(form).on('click', '[data-send="support"]', function (event) {
            event.preventDefault();


            const form = event.target.closest('form')
            let button = this

            // telefon düzenleme
            var values = $(form).serializeArray()

            $.ajax({
                url: apiUrl + '/SupportSendCreate',
                type: "POST",
                dataType: "json",
                data: values,
                async: true,
                error: function error(xhr) {
                    //console.log(xhr)
                    SwalMessage(
                        {
                            type: 'error',
                            text: xhr.responseJSON.text ?? xhr.responseJSON.message,
                            confirmButton: translate.ok_button,
                        },
                        function () {
                            // location.reload();
                            button.removeAttribute('disabled');
                        }
                    );
                },
                beforeSend: function () {
                    button.setAttribute('disabled', '');
                },
                complete: function () {
                    button.removeAttribute('disabled');
                },
                success: function success(xhr) {
                    //console.log(xhr)

                    button.setAttribute('disabled', '');

                    ToastMessage('0', translate.request_text, xhr.text ?? xhr.message)
                    location.reload();
                }
            });
        })

    }


    return {
        init: function () {
            form = document.querySelector('[data-form="support"]')
            if (form) {
                handle();
            }
        },
    };

}();




$(function () {
    Support.init();
});